module.exports = __webpack_public_path__ + "img/action_3rd.aa56d77.png";